export interface RuntimeConfig {
  [key: string]: string;
}

let config: RuntimeConfig | null = null;

export async function loadRuntimeConfig() {
  if (config) {
    return;
  }

  const url = '/api/runtime-config';

  try {
    const response = await fetch(url, { cache: 'no-store' });

    if (!response.ok) {
      throw new Error(
        `[loadRuntimeConfig] Response status: ${response.status}`,
      );
    }

    const result = await response.json();

    config = Object.fromEntries(
      Object.entries(result).map(([k, v]) => [k, String(v)]),
    );
  } catch (error: any) {
    throw new Error(error?.message ?? error);
  }

  (window as any).env = {
    ...(window as any).env,
    ...config,
  };
}
